// extracted by mini-css-extract-plugin
module.exports = {"root":"backMobileMenu_root__1DKD5","button":"backMobileMenu_button__1utuI"};